/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {TaskHandoverDTO} from "./task-handover-dto.model";
import {TaskCheckpointType} from "./task-checkpoint-type.enum";
import { Maybe } from '@irian-ro/util-functions';
import { PackageVoModel } from '@well/delivery-libs/packages/domain';

export class TaskCheckpointDTO extends JSONable {

  uuid: Maybe<string> | undefined = undefined;
  taskUuid: Maybe<string> | undefined = undefined;
  taskHandoverDTO: Maybe<TaskHandoverDTO> | undefined = undefined;
  type: Maybe<TaskCheckpointType> | undefined = undefined;
  packageVOs: PackageVoModel[] = [];
}
